import URI from "urijs";

export interface IJsonObject {
	[key: string]: any;
}

type Fetch = (path: RequestInfo, init?: RequestInit) => Promise<Response>;

export class ApiService {
	private fetch: Fetch;

	constructor(fetch?: Fetch) {
		if (!fetch) {
			this.fetch = window.fetch.bind(window);
		} else {
			this.fetch = fetch;
		}
	}

	public async get(path: string, params?: object): Promise<Response> {
		const uri = new URI(path);
		if (params) {
			uri.setSearch(params);
		}

		return this.fetch(uri.toString(), params);
	}

	public async post(path: string, body?: object): Promise<Response> {
		let headers;

		if (body) {
			headers = {
				"Content-Type": "application/json",
			};
		}

		return this.fetch(path, {
			method: "post",
			body: body ? JSON.stringify(body) : undefined,
			headers,
		});
	}

	public async delete(path: string): Promise<Response> {
		return this.fetch(path, {
			method: "DELETE",
		});
	}

	public async uploadFile(path: string, body: FormData): Promise<Response> {
		return this.fetch(path, {
			method: "post",
			body,
		});
	}
}
